import { HeroSectionWrapper } from 'App/SuccessPage';
import { AuthHeader, FullPageAuth, useAuth } from '@kitopi-com/customer-auth';
import { useAccessPoint } from 'context/AccessPointContext';
import { useBrandContext } from 'context/BrandContext';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { useHandleAccessPointConnection } from 'hooks/useHandleAccessPointConnection';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { getSearchParams } from 'utils/getSearchParams';
import phoneLargeImg from '../../assets/images/phone-large.webp';
import phoneMobileImg from '../../assets/images/phone-mobile.webp';
import { useCustomFields } from '../../auth/config/customFields';
import { LoginPageContainer } from './LoginPage.styles';
import { SignInToWifiInstant } from './SignInToWifiInstant';

export const LoginPage = () => {
  const navigateTo = useNavigate();
  const { search } = useLocation();
  const params = getSearchParams(search);
  const { state } = useAuth();
  const {
    isAuthorizedToAccessPoint,
    isWaitingForAuthStatus,
    setIsWaitingForAuthStatus,
    setIsAuthorizedToAccessPoint,
    setIsStartAuthorizingToAP,
  } = useAccessPoint();

  const [isLoading, setIsLoading] = useState(true);
  const { isAuthorized } = useHandleAccessPointConnection({
    enabled: isLoading || isWaitingForAuthStatus,
    setIsLoading,
  });
  useEffect(() => {
    if (isAuthorized) {
      setIsWaitingForAuthStatus(false);
      setIsAuthorizedToAccessPoint(true);
    }
  }, [isAuthorized]);

  useEffect(() => {
    if (!isLoading) {
      setIsStartAuthorizingToAP(false);
    }
  }, [isLoading]);

  const {
    state: { checkIsSignedIn: checkIsSignedInAsKitopiCustomer },
  } = useAuth();
  const { brand } = useBrandContext();
  const customFields = useCustomFields();

  useEffectOnce(async () => {
    try {
      await checkIsSignedInAsKitopiCustomer();
    } catch {
      // Expected in captive portal - user has no internet yet
    }
  });

  useEffect(() => {
    if (isAuthorizedToAccessPoint) {
      navigateTo(`/auth?reload_number=1&siteName=${params.siteName}`);
    }
  }, [isAuthorizedToAccessPoint]);

  return (
    <LoginPageContainer>
      <FullPageAuth
        welcomeHeader={
          <AuthHeader
            title="Welcome!"
            subtitle="Sign in to access your account"
            logo={<img src={brand.logo} alt={brand.siteName} />}
          />
        }
        customFields={customFields}
        {...(state.isSignedIn && {
          successContainer: <SignInToWifiInstant visible={state.isSignedIn} />,
        })}
        heroSection={{
          mobile: (
            <HeroSectionWrapper
              imageSrc={phoneMobileImg}
              imageAlt="Phone Mobile"
              imageWidth="70%"
              isSignedIn={false}
              translateY="55%"
            />
          ),
          tabletPortrait: (
            <HeroSectionWrapper
              imageSrc={phoneLargeImg}
              imageAlt="Phone Large"
              imageWidth="50%"
              isSignedIn={false}
              translateY="32%"
            />
          ),
          tabletLandscape: (
            <HeroSectionWrapper
              imageSrc={phoneLargeImg}
              imageAlt="Phone Large"
              imageWidth="80%"
              translateY="15%"
              isSignedIn={false}
            />
          ),
          desktop: (
            <HeroSectionWrapper
              imageSrc={phoneLargeImg}
              imageAlt="Phone Large"
              imageWidth="75%"
              translateY="17%"
              isSignedIn={false}
            />
          ),
        }}
      />
    </LoginPageContainer>
  );
};
